import { useEffect, useState } from "react";
import React from "react";
import { Link } from "react-router-dom";
import Api from "../../Api/Api";
import "./Trending.css";
import { username } from "../../API";

const TrendingHome = () => {
  const [trending, setTrending] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      try {
        const { data } = await Api.getTranding();
        setTrending(data);
        console.log("setTrending", data)

      } catch (error) {
        console.error("Error fetching trending data:", error);
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, [username]);
  const generateSlug = (title, id) => {
    return `${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-${id}`;
  };
  const slugify = (text = "") => {
    return `${text.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`
  };

  return (
    <div className="trending-home">
      {loading ? (
        <div className="loading-indicator">
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
        </div>
      ) : trending?.length !== 0 ? (
        <>
          <h5 className="trending-title" style={{
            color: "black",
            fontWeight: 600,
            marginBottom: "1rem",
            fontSize: "1.5rem"
          }}>Trending</h5>

          {/* Cards Grid */}
          <div className="trending-grid">
            {trending?.map((movie, index) => (
              <Link to={
                movie?.channelType === "Subchannels"
                  ? `/${slugify(movie?.channel?.parentChannel?.name)}/channel/${slugify(movie?.channel?.name)}/${generateSlug(movie?.title, movie._id)}`
                  : `/${slugify(movie?.channel?.name)}/${generateSlug(movie?.title, movie._id)}`
              } className="movie-link" key={index}>
                <div className="movie-card">
                  <img
                    src={`${movie.thumbnail}`}
                    alt={`${movie.title}`}
                    className="movie-thumbnail"
                  />
                  <div className="movie-info">
                    <span className="movie-title">{movie.title}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </>
      ) : (
        <p>No trending data available</p>
      )
      }
    </div >
  );
};

export default TrendingHome;
